import React from 'react';
import ReactDOM from 'react-dom';
import ChatSection from './feedbackdetail/ChatSection';
import { connect } from 'react-redux';
import Smiley from './Smiley';
import ReviewSection from './feedbackdetail/ReviewSection';
import FeedbackNote from './feedbackdetail/FeedbackNote';
import FeedbackSection from './feedbackdetail/FeedbackSection';
import NoteSection from './feedbackdetail/NoteSection';
import AttachmentSection from './feedbackdetail/AttachmentSection';
import StatusSection from './feedbackdetail/StatusSection';
import TagsSection from './feedbackdetail/TagsSection';
import TextMessageForward from './feedbackdetail/TextMessageForward';
import { setSelectedFeedback, ajaxFeedback, getRequestedVia, getStarsJSX, getChatStatus, reviewLinkSent, getAttachmentsUrls, ajaxUpdateFeedbackStatus, genEmailButton, updateModalContent } from './redux/FeedbackRedux';


class UserTable extends React.Component {

    handleClick() {
        if (document.referrer.includes("/feedbacker-list")) {
            window.location = "/business/" + this.props.state.business.business_id + "/feedbacker-list";
        } else {
            window.location = "/dashboard";
        }
    }

    render() {


        return (
            <div className="col-sm-12 mt-3">

                <div className="card">
                    <div className="title-row border-bottom">
                        <div className="card-title tab">
                            <h5 className="heading-main pl-3 pr-3">{((this.props.state.user_table && this.props.state.user_table.firstname) ? (this.props.state.user_table.firstname + " " + (this.props.state.user_table.lastname ?? '')).trim() : "Anonymous")}</h5>
                        </div>

                        <div className="card-title card-title-end ml-auto pr-2">
                            <a href="#" className="btn btn-outline-secondary btn-sm mr-1" onClick={this.handleClick.bind(this)}>{__('Back')}</a>
                        </div>
                    </div>

                    <div className="card-body card-body-table pt-0 pb-0">
                        <table className="table table-striped table-feedbacker-list mb-0 pb-0">
                            <thead>
                                <tr>
                                    <th className="border-top-0">{__('First Name')}</th>
                                    <th className="border-top-0">{__('Last Name')}</th>
                                    <th className="border-top-0">{__('Phone')}</th>
                                    <th className="border-top-0">{__('Email')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr id="">
                                    <td>
                                        <span>{(this.props.state.user_table.firstname) ? this.props.state.user_table.firstname : "none"}</span>
                                    </td>
                                    <td>
                                        <span>{(this.props.state.user_table.lastname) ? this.props.state.user_table.lastname : "none"}</span>
                                    </td>
                                    <td>
                                        <span>{this.props.state.user_table.phone ? this.props.state.user_table.phone : "none"}</span>
                                    </td>
                                    <td>
                                        {this.props.state.user_table.email &&
                                            <a href={"mailto:" + this.props.state.user_table.email}>{(this.props.state.user_table.email) ? this.props.state.user_table.email : "none"}</a>
                                        }
                                        {!this.props.state.user_table.email &&
                                            <p>{__('none')}</p>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        );
    }

}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(UserTable)
